/**
 * Image helper utility for opening base64 data URLs & URLs safely in new tabs without about:blank
 */
export const openImageInNewTab = (imageSrc, title = "Image Preview") => {
  if (!imageSrc) return;

  if (typeof imageSrc === "string" && imageSrc.startsWith("data:")) {
    try {
      const parts = imageSrc.split(";base64,");
      if (parts.length === 2) {
        const contentType = parts[0].split(":")[1] || "image/png";
        const raw = window.atob(parts[1]);
        const rawLength = raw.length;
        const uInt8Array = new Uint8Array(rawLength);

        for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        }

        const blob = new Blob([uInt8Array], { type: contentType });
        const blobUrl = URL.createObjectURL(blob);
        const win = window.open(blobUrl, "_blank");
        if (win) return;
      }
    } catch (e) {
      console.warn("Blob URL conversion fallback triggered:", e);
    }

    // Fallback HTML page writer
    const win = window.open("", "_blank");
    if (win) {
      win.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <title>${title}</title>
            <style>
              body {
                margin: 0;
                background-color: #0f172a;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                min-height: 100vh;
                font-family: system-ui, -apple-system, sans-serif;
              }
              img {
                max-width: 95vw;
                max-height: 90vh;
                object-fit: contain;
                border-radius: 12px;
                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
              }
              .toolbar {
                position: fixed;
                top: 16px;
                right: 16px;
                display: flex;
                gap: 8px;
              }
              .btn {
                background: rgba(255,255,255,0.15);
                color: #ffffff;
                border: 1px solid rgba(255,255,255,0.25);
                padding: 8px 16px;
                border-radius: 8px;
                cursor: pointer;
                font-size: 13px;
                font-weight: 600;
                backdrop-filter: blur(8px);
                text-decoration: none;
              }
              .btn:hover { background: rgba(255,255,255,0.3); }
            </style>
          </head>
          <body>
            <div class="toolbar">
              <a href="${imageSrc}" download="image_preview.png" class="btn">Download Image</a>
            </div>
            <img src="${imageSrc}" alt="${title}" />
          </body>
        </html>
      `);
      win.document.close();
      return;
    }
  }

  window.open(imageSrc, "_blank");
};
